import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-leaderboard-game-card',
  templateUrl: './leaderboard-game-card.component.html',
  styleUrls: ['./leaderboard-game-card.component.scss']
})
export class LeaderboardGameCardComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
